import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import { OverlayPanel } from 'primeng/primeng';
import 'fullcalendar/dist/locale/pt-br.js';
import randomColor from 'randomcolor';
import { take } from 'rxjs/operators';
import * as moment from 'moment'
import _ from 'lodash';

import { MSEvent } from '../shared/model/ms_event.dto';
import { UserModel } from '../shared/model/user.model';
import { EmailModel } from '../shared/model/email.model';
import { UserService } from '../shared/service/user.service';
import { ReportService } from '../shared/service/report.service';
import { ChecklistModel } from '../shared/model/checklist.model';
import { SchedulingDto } from '../shared/model/ms_scheduling_dto';
import { SchedulingService } from '../shared/service/scheduling.service';
import { MessageComponent } from '../shared/component/message/message.component';
import { PrimeFaceScheduleEvent } from '../shared/model/ms_scheduling_primeface';
import { ChecklistResponseModel } from '../shared/model/question_response.model copy';
import { CalendarLocale, SchedulingCalendar } from '../shared/static/calendar-locale';
import { msRecurrenceOptions, msRecurrencePattern, RecurrenceDto } from '../shared/model/ms_recurrence';

@Component({
    selector: 'scheduling-component', 
    templateUrl: 'scheduling.component.html', 
    styleUrls: ['./scheduling.component.css']
})
export class SchedulingComponent implements OnInit {
    @ViewChild(MessageComponent) message: MessageComponent;

    selectedDate: string
    isOpen: boolean = true
    currentUserEmail: EmailModel
    header = {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay'
    };

    // primeng format
    dayEvents: PrimeFaceScheduleEvent[] = null;
    dayEvent: PrimeFaceScheduleEvent = null;
    events: PrimeFaceScheduleEvent[] = [];
    options = SchedulingCalendar;

    // Vars
    calendarLocale = CalendarLocale;
    // dateFormat = 'dd/MM/yy';
    init_date = null;
    end_date = null;
    repeat = false;
    delay = 600;

    // LOCAL GETTER (Selection)
    recurrenceForm = new RecurrenceDto()
    recurrenceFormOptions = {};
    recurrenceOptions = [];
    checklists: any[] = [];
    calendars: any[] = [];
    responses: any[] = [];
    checklistOptions = [];
    responseOptions = [];
    users: any[] = []
    userOptions = [];

    // LOCAL RESPONSES (Selected)
    newCalendar: { calendarName: string } = { calendarName:'' };
    checklist: ChecklistModel = new ChecklistModel();
    response: ChecklistResponseModel = null;
    user: UserModel = null;
    recurrence = null;
    calendar = '';
    // lastEvent: any;

    // Shared Vars
    rawUsers: UserModel[] = [];
    loading = false;

    // Translate Keys
    selectKey = '';

    constructor(
      protected userService: UserService,
      protected reportService: ReportService,
      protected translateService: TranslateService,
      protected schedulingService: SchedulingService,
    ) {}

    ngOnInit() {
      // get from api
      this.getUsers();
      this.getRecurrence();
      this.getChecklists();
      this.getChecklistResponses();

      // load from ms
      this.loadCalendars();
    }

    loadCalendars() {
      this.schedulingService.listCalendars()
        .subscribe((response: any) => {
          for (const calendar of response) {
            this.calendars.push({
              label: calendar.name,
              value: calendar.id,
            });
          }

          // auto load first calendar items
          this.calendar = this.calendars[0] && this.calendars[0].value || '';
          this.loadEvents();
        }
      );
    }

    loadEvents(calendarId?: string) {
      if (calendarId || this.calendar)
      this.schedulingService.getCalendarEvents(
        calendarId || this.calendar
      ).subscribe((res: MSEvent[]) => {
          this.events = res.map((ms_event: MSEvent) => {
            const model = PrimeFaceScheduleEvent.format(ms_event);

            model.backgroundColor = randomColor({ luminosity: 'dark' });

            return model;
          });
        }
      );
    }

    translateOptions(opts: any[], field = 'value', key: string | boolean = 'select') {
      const keyToTranslate = (key || '').toString().toLowerCase();
      return [
        ...(key ? [{ label: this.translateService.instant(keyToTranslate), value: null }] : []),
        ...(opts.map(p => ({ label: this.translateService.instant(p[field]), value: p.value }))),
      ];
    }

    getRecurrence() {
      this.translateService.get('translate_version').pipe(take(1)).subscribe(_ => {
        this.selectKey = this.translateService.instant('select_o');

        this.recurrenceOptions = this.translateOptions(msRecurrenceOptions.recurrenceOptions, 'value', 'one_time');

        this.recurrenceFormOptions = {
          monthOptions: this.translateOptions(msRecurrenceOptions.monthOptions, 'label'),
          rangeTypeOptions: this.translateOptions(msRecurrenceOptions.rangeTypeOptions, 'label'),
          indexOfWeekOptions: this.translateOptions(msRecurrenceOptions.indexOfWeekOptions, 'value'),
          dayOfWeekOptions: this.translateOptions(msRecurrenceOptions.dayOfWeekOptions, 'value', false),
        };
      });
    }

    getUsers() {
      this.userService.getAllPaginated().subscribe((res) => {
          this.rawUsers = res && res.rows && res.rows.filter(u => u && u.email) || [];
  
          for (const user of this.rawUsers) {
            this.userOptions.push({
              label: user.name,
              value: user,
            });
          }
      });
    }

    getChecklists() {
      this.checklistOptions = [{ label: '', value: null }];

      this.reportService.getChecklists({
        uniqueChecklists: true,
        withHeaderItems: true,
        withQuestions: false,
        withDefaults: false,
        withEmails: false,
        paranoid: false
      }).pipe(take(1))
      .subscribe((checklists: any) => {
        if (checklists && checklists.length)
        for (const check of checklists) {
          this.checklistOptions.push({
            label: check.name,
            value: check
          });
        }

        console.info('loaded_checklists');
      });
    }

    getChecklistResponses() {
      this.responseOptions = [{ label: '', value: null }];

      this.reportService.getResponses({}).pipe(take(1))
      .subscribe((responses: any) => {
        if (responses && responses.length)
        for (const response of responses) {
          this.responseOptions.push({
            value: response, label: `
              ${response.id}: ${response && response.checklist.name || 'Invalid Name'}
            `,
          });
        }

        console.info('loaded_checklists');
      });
    }

    onSwitchChange({ checked }) {
      this.repeat = checked;
    }

    modalChangeState(event, eventModal, anotherModal?, reset?) {
      const target = event.target || event.jsEvent.target || event.originalEvent.target;

      // clean last selection
      if (reset) this.dayEvent = null;

      // close another modal
      if (anotherModal && anotherModal.visible) anotherModal.hide({ target });

      // open new modal
      eventModal && eventModal.visible ? eventModal.hide({ target }) : eventModal.show({ target });

      // eventModal.el.nativeElement.lastElementChild.style.left = '70px'
      // eventModal.el.nativeElement.firstElementChild.style.left = '70px'

      // use dynamic setter style instead code above
      // this code fixes the layout size bug that opens the modal outside the view
      const modals = eventModal && eventModal.el && eventModal.el.nativeElement &&
      eventModal.el.nativeElement.getElementsByClassName('ng-trigger-panelState');

      for (const modal of modals) {
        const leftStr = window.getComputedStyle(modal).left.trim();

        if (!leftStr || leftStr == '0' || leftStr == '0px') {
          modal.style['margin-left'] = '50px';
          modal.style.left = '50px';
          continue;
        }

        const cleaned = leftStr.replace('px', '').replace(',', '.');
        const leftNum = parseFloat(cleaned);

        if (!isNaN(leftNum) && leftNum > 150) {
          modal.style['margin-left'] = '0px';
          modal.style.left = '0px';
        } else {
          modal.style['margin-left'] = '150px';
          modal.style.left = '150px';
        }

      }
    }

    dayClick(event, updateModal: any, createModal: any) {
      let date: Date = new Date() as Date;
      //date.setDate(date.getDate() + 1);
      date.setHours(10);

      if (
        !isNaN(
          event.date &&
          event.date.isValid &&
          event.date.isValid() && 1
        )
      ) {
        event.date.hour(10);
        //event.date.add(1, 'day');
        date = event.date.toDate();
      }

      // set the selected day
      this.init_date = date;
      this.end_date = date;

      // clean the last event
      this.resetEvent(true);

      this.modalChangeState(event, createModal, updateModal);
    }

    dayClickFirstEventOpen(event, eventUpdateModal, eventCreateModal) {
      const dayEvents = this.events && this.events.filter(e =>
        (
          moment(event && event.date).format("DD/MM/YYYY")
        ) == (
          moment(e && e.date).format("DD/MM/YYYY")
        )
      ) || [];

      if (!dayEvents.length) this.modalChangeState(event, eventCreateModal, eventUpdateModal);
      else this.modalChangeState(event, eventUpdateModal, eventCreateModal);

      this.dayEvent = dayEvents.length ? dayEvents[0] : null;
      this.dayEvents = dayEvents.length ? dayEvents : [];
    }

    eventClick(event, eventUpdateModal, eventCreateModal) {
      const dayEvent = this.events && this.events.find(e => e.id == event.calEvent.id);

      if (!dayEvent) this.modalChangeState(event, eventCreateModal, eventUpdateModal);
      else this.modalChangeState(event, eventUpdateModal, eventCreateModal);

      this.dayEvent = dayEvent || null;
    }

    dayEventHandler(data) {
      this.loading = true;

      if (data && data.action) {
        switch (data.action) {
          case 'create':
            return this.createDayEvent(data.event_dto);
          case 'update':
            return this.updateDayEvent(data.event_dto);
          case 'cancel':
            return this.cancelDayEvent(data.event_dto);
          case 'reset':
            return this.resetEvent();
          default:
            break;
        }
      }
    }

    createCalendar(event, modal) {
      const target = event.target || event.jsEvent.target || event.originalEvent.target;

      this.schedulingService.createCalendar(this.newCalendar).subscribe(
        _ => modal && modal.visible && modal.hide({ target }),
        (res) => this.errorHandler(res && res.error || res),
      );
    }

    createDayEvent(event) {
      this.schedulingService.create(event).subscribe(
        (res: MSEvent) => {
          if (res.id) this.resetEvent();
          this.events.push(PrimeFaceScheduleEvent.format(res));
        },
        (res) => this.errorHandler(res && res.error || res),
      );
    }

    updateDayEvent(event) {
      this.schedulingService.updateAsComplete(event.id, event.response_id).subscribe(
        (res: MSEvent) => this.mergeChangedEvent(event, res),
        (res) => this.errorHandler(res && res.error || res),
      );
    }

    cancelDayEvent(event) {
      this.schedulingService.delete(event.id).subscribe(
        (res: MSEvent) => this.mergeChangedEvent(event, res, true),
        (res) => this.errorHandler(res && res.error || res),
      );
    }

    mergeChangedEvent(event: MSEvent, newEvent: MSEvent, exclude = false) {
      const updatedIndex = this.events && this.events.length ?
      this.events.findIndex(e => e.id == event.id) : -1;

      if (updatedIndex > -1) {
        if (exclude) this.events = this.events.filter((_, i) => i != updatedIndex);
        if (!exclude) this.events[updatedIndex] = PrimeFaceScheduleEvent.format(newEvent);
      }

      this.resetEvent();
    }

    resetEvent(keepDate = false) {
      this.users = [];
      this.dayEvents = [];
      this.responses = [];
      this.checklists = [];

      this.user = null;
      this.response = null;
      this.dayEvent = null;
      this.recurrence = null;
      this.checklist = new ChecklistModel();
      this.recurrenceForm = new RecurrenceDto();

      if (!keepDate) {
        this.end_date = null;
        this.init_date = null;
      }

      setTimeout(() => { this.loading = false }, 500);
    }

    duplicateValidation = () => this.calendars.some(c => this.newCalendar && this.newCalendar.calendarName == c.name)

    public translate = (key: string) => this.translateService && this.translateService.instant(key) || key;

    protected errorHandler(error: any = {}) {
      const [errors, params] =  error.message && error.message.includes(':') ? error.message.split(':') : [error.message, '.'];
      this.message.error(this.translate(errors) + ' ' + this.translate(params));
      console.error(error);
      return;
  }

    // not will be a modal
    // openCalendarSelector(event, modal) {
    //   const target = event.target || event.jsEvent.target || event.originalEvent.target;
    //   modal && modal.visible ? modal.hide({ target }) : modal.show({ target });
    // }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/scheduling/scheduling.component.ts